import React from 'react';

export default function Live() {
  const youtubeLink = "https://www.youtube.com/@Technopal2023";

  return (
    <div className="container py-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold"> البث المباشر</h2>
        <p className="text-muted">شاهد البث الآن مباشرة عبر قناتنا على YouTube</p>
      </div>

      <div className="ratio ratio-16x9 mb-4">
        <iframe
          src={youtubeLink}
          title="البث المباشر"
          allowFullScreen
        ></iframe>
      </div>

      <div className="text-center">
        <a
          href={youtubeLink.replace('/embed/', '/watch?v=')}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-danger"
        >
          مشاهدة على YouTube
        </a>
      </div>
    </div>
  );
}
